import { Component, Input, OnInit, SimpleChanges, OnChanges } from "@angular/core";

@Component({
    selector: "edp-progress-bar",
    templateUrl: "./edp-progress-bar.component.html",
    styleUrls: ["./edp-progress-bar.component.scss"],
})
export class EdpProgressBarComponent implements OnInit, OnChanges {
    @Input() fullValue: any;
    @Input() currentValue: any;
    
    @Input() primaryColor: string;
    @Input() secondaryColor: string;

    public barWidth = "";

    ngOnInit(): void {
        this.mountBar();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.currentValue) {
            this.mountBar();
        }
    }

    calculateBarWidth(fullValue, currentValue) {
        return Math.round((Number(currentValue) * 100) / Number(fullValue));
    }

    mountBar() {
        if (Number(this.currentValue) >= 0 && Number(this.currentValue) <= Number(this.fullValue)) {
            this.barWidth = this.calculateBarWidth(this.fullValue, this.currentValue) + "%";
        }
    }
}
